import { shadeTierColor } from "../../../../utils/loyalty/tiers";
import { MEDAL_PATHS } from "../artPaths";
import {
  LoyaltyTierHexagon,
  LoyaltyTierHexagonGradient,
} from "../Badge/LoyaltyTierBadge";
import styles from "./LoyaltyTierMedal.module.scss";

/**
 * Figma ribboned medal (24x40) shown next to the points balance on the menu
 * tab. The ribbon is tinted with the tier colour and the hexagon is the shared
 * badge artwork scaled onto the medal grid.
 */
export const LoyaltyTierMedal = ({
  rank,
  color,
  title,
}: {
  rank: number;
  color: string;
  title?: string;
}) => (
  <svg
    className={styles.tier_medal}
    width="24"
    height="40"
    viewBox="0 0 24 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role={title ? "img" : "presentation"}
    aria-hidden={title ? undefined : true}
    focusable="false"
  >
    {title && <title>{title}</title>}
    <defs>
      <LoyaltyTierHexagonGradient color={color} />
      <linearGradient
        id={`tier_medal_${color.replace(/[^\da-z]/gi, "")}`}
        x1="12.27"
        y1="0.38"
        x2="11.98"
        y2="19.9"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FFFFFF" />
        <stop offset="1" stopColor={color} />
      </linearGradient>
    </defs>
    <path
      d={MEDAL_PATHS.ribbon}
      fill={`url(#tier_medal_${color.replace(/[^\da-z]/gi, "")})`}
    />
    <path
      d={MEDAL_PATHS.frame}
      // The ribbon's frame and its fold lines sit under the same 30% black as
      // the engraved rank.
      fill={shadeTierColor(color)}
    />
    <g transform="translate(3 19.75) scale(0.75)">
      <LoyaltyTierHexagon rank={rank} color={color} />
    </g>
  </svg>
);
